import { proizvodService } from '../services/proizvod.service';
import Vue from 'vue'

const state = {
    proizvod: [],
    sezona:null,
    pridelovalecid:null
};

const actions = {
    load({ dispatch,commit },{sezona,pridelovalecid,makeEditable}) {
        dispatch('alert/clear', "",{ root: true });
        commit('setSezona', sezona)
        commit('setPridelovalecID', pridelovalecid)
      return proizvodService.load(sezona,pridelovalecid)
            .then(
                proizvod => {
                  commit('load', proizvod);
                  if(makeEditable)
                  commit('makeEditable') 
                  return proizvod;                   
                } 
                
            );
    },
       loadPreteklaSezona({ dispatch,commit },{sezona,pridelovalecid,makeEditable}) {
         dispatch('alert/clear', "",{ root: true });
        //commit('setSezona', sezona)
        //commit('setPridelovalecID', pridelovalecid)
        return new Promise((resolve, reject) => {

        
       proizvodService.loadPreteklaSezona(sezona,pridelovalecid)
            .then(
                proizvod => {
                
                    proizvod.forEach(e=>{
                        e.id=null;
                        commit("add",e);
                    });

                  if(makeEditable)
                  commit('makeEditable') 
                  resolve(proizvod);                   
                },
                error =>{
                    console.log(error);
                    dispatch('alert/error', "Nalaganje ni uspelo", { root: true });
                    reject(error);
                }
                
            );
        });
    },
    loadVse({ dispatch,commit },{sezona}) {
          dispatch('alert/clear', "",{ root: true });
        commit('load');
          commit('setSezona', sezona)
       return  proizvodService.loadAll(sezona)
            .then(
                proizvod => commit('load', proizvod)
                //,
                //error => commit('getLoggedInFailure', error)
            );
    },
     
    save({ dispatch, commit }) {
     

         console.log("Shranjujem!");
        let sezona=this.state.proizvod.sezona;
        let pridelovalecid=this.state.proizvod.pridelovalecid;
        console.log(this.state);
        dispatch('alert/clear', "",{ root: true });

        this.state.proizvod.proizvod.forEach(item=>{
            item.sezona=sezona;
            item.pridelovalecid=pridelovalecid;
            console.log(item);
            if(!item.proizvodid) {
                 item.saved=false;
                dispatch('alert/error', "Šifrant ni ustrezno izbran", { root: true });

            }
            else if(item.jeaktivna){
              proizvodService.save(item)
               .then(
                proizvod => {
                      Vue.set(item,'saved',true);
                     Vue.set(item,'id',proizvod.id);
                     Vue.set(item,'jeaktivna',1); 
                   // commit("update",item);
                    
                },
                error => {
                    console.log(error);
                     Vue.set(item,'saved',false);
                    //commit("update",item);
                    dispatch('alert/error', "Shranjevanje ni uspelo", { root: true });
                }
            );
            }
            else
             proizvodService.save(item).then(
                proizvod => {
                     Vue.set(item,'saved',true);
                    //commit("update",item);
                    
                },
                error => {
                    console.log(error);
                     Vue.set(item,'saved',false);
                  //  commit("update",item);
                    dispatch('alert/error', "Brisanje ni uspelo", { root: true });
                });
            //tukaj naredi ikono, da je shranjvanje uspešno na začetku ali nekje
            //uporabi info, če je prišlo kje do napake!

          });
       
        
    }
};

const mutations = {
  
    load(state, proizvod) {
       if(proizvod)
        state.proizvod=proizvod.map(k=>{
            k["veljavnostcertifikataod"]=kendo.parseDate(k["veljavnostcertifikataod"]) 
            let infonosilec=k.opomba?.split(";");
            if(Array.isArray(infonosilec)&&infonosilec.length==3){
                k.naslovnosilca=infonosilec[0];
                k.postnastevilkanosilca=infonosilec[2];
                k.postanosilca=infonosilec[1];
            }
            return k;
        }
            );   
    },
    add(state, item) {
        if(!item.id) {
            //do id
            var minid=state.proizvod.reduce((prev, curr) => prev.id < curr.id ? prev : curr,{id:0}).id;
            if(minid>0)
                minid=0;
            minid--;
            item.id=minid;
        }
        state.proizvod.push(item);
    },
    setSezona(state, item) {
        state.sezona=item;
    },
    makeEditable(state){
        for (var i=0;i<state.proizvod.length;i++){
            let dateStr=state.proizvod[i].veljavnostcertifikataod;
            if(dateStr)
                state.proizvod[i].veljavnostcertifikataod=new Date(dateStr);
            else
                state.proizvod[i].veljavnostcertifikataod=new Date( );
            let updated = Object.assign({}, state.proizvod[i], { inEdit: true });
            state.proizvod.splice(i,1,updated);
        }
        

    },
    setPridelovalecID(state, item) {
        state.pridelovalecid=item;
    },
  
    update(state, item) {
        //state.kultura = kultura;
        //state.kultura;
       
        let updated;
        let itemID = item.id
            let index = state.proizvod.findIndex(p =>
                (JSON.stringify({ ...p }) === JSON.stringify(item) )
                 || itemID && p.id === itemID);
            if (index >= 0) {
                updated = Object.assign({}, item);
                state.proizvod.splice(index,1,updated);
            } else {
                let id = 1;
                state.proizvod.forEach(p => { id = Math.max(p.id + 1, id); });
                updated = Object.assign({}, item, { id: id });
                state.proizvod.unshift(updated);
                index = 0;
            }



        //    return data[index];
        //state.kultura=data;

    },
    remove(state, item) {
        let itemID = item.id
            let index = state.proizvod.findIndex(p =>
                (JSON.stringify({ ...p }) === JSON.stringify(item) )
                 || itemID && p.id === itemID);
                console.log("Brisem!");
                console.log(index);
                console.log(state.proizvod);
                state.proizvod.splice(index, 1);
        
        //    return data[index];
        //state.proizvod=data;

    },
    replace(state, proizvod) {
        state.proizvod = proizvod;
    }
   
};

export const proizvod = {
    namespaced: true,
    state,
    actions,
    mutations
};
